import React from "react";
import { useNavigate } from "react-router-dom";
import "@fontsource/merienda";
import "@fontsource/merienda/900.css";
import "@fontsource/manrope";
import "@fontsource/manrope/600.css";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-page-font min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-100 flex items-center justify-center px-6 relative overflow-hidden">

      {/* Soft Background Glow */}
      <div className="absolute w-[500px] h-[500px] bg-orange-200/30 rounded-full blur-3xl top-[-100px] right-[-100px]" />
      <div className="absolute w-[400px] h-[400px] bg-orange-300/20 rounded-full blur-3xl bottom-[-100px] left-[-100px]" />

      <div className="relative text-center max-w-2xl">

        {/* 404 Text */}
        <h1 className="text-[120px] sm:text-[160px] md:text-[200px] font-extrabold text-orange-500 leading-none tracking-tight drop-shadow-sm">
          404
        </h1>

        {/* Heading */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-6">
          Oops! This Page Got Lost.
        </h2>

        {/* Description */}
        <p className="text-gray-600 font-body text-base sm:text-lg mb-10 max-w-md mx-auto">
          The page you are looking for doesn’t exist or has been moved.
          Let’s take you back where things are working perfectly.
        </p>

        {/* Button */}
        <button
          onClick={() => navigate("/")}
          className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 active:scale-95 font-semibold"
        >
          Back To Home
        </button>

      </div>
    </div>
  );
};

export default NotFound;